import { render, staticRenderFns } from "./subtitleIntro.vue?vue&type=template&id=954f6674&scoped=true&"
import script from "./subtitleIntro.vue?vue&type=script&lang=js&"
export * from "./subtitleIntro.vue?vue&type=script&lang=js&"
import style0 from "./subtitleIntro.vue?vue&type=style&index=0&id=954f6674&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f6674",
  null
  
)

export default component.exports